import React from "react"
import InsightPage from '../../components/Insight/InsightPage';
import TopImage from '../../images/Service-hero-why-restaurants-need-to-evolve.jpg';

export default () => {
  return (
    <InsightPage slugParam={"why-restaurants-should-evolve-their-in-house-ordering-technology-in-a-post-covid-19-world"}
    topImage={TopImage}
    />
  )};